<template>
  <div class="uk-width-1-4@m bg_gray sidebar">
    <div class="uk-section uk-padding-small">
      <div class="sp_flex">
        <div class="uk-margin-large-bottom level">
          <fieldset class="uk-fieldset">
            <legend class="uk-legend">難易度</legend>
            <div class="uk-margin">
              <label class="uk-display-block uk-margin-small-bottom"
                ><input
                  class="uk-radio"
                  type="radio"
                  @change="handleChangeQuery"
                  v-model="level"
                  name="radio2"
                  value=""
                  checked
                />
                全て</label
              >
              <label class="uk-display-block uk-margin-small-bottom"
                ><input
                  class="uk-radio"
                  type="radio"
                  @change="handleChangeQuery"
                  v-model="level"
                  name="radio2"
                  value="初級"
                />
                初級</label
              >
              <label class="uk-display-block uk-margin-small-bottom"
                ><input
                  class="uk-radio"
                  type="radio"
                  @change="handleChangeQuery"
                  v-model="level"
                  name="radio2"
                  value="中級"
                />
                中級</label
              >
              <label class="uk-display-block uk-margin-small-bottom"
                ><input
                  class="uk-radio"
                  type="radio"
                  @change="handleChangeQuery"
                  v-model="level"
                  name="radio2"
                  value="上級"
                />
                上級
              </label>
            </div>
          </fieldset>
        </div>
        <div class="uk-margin-large-bottom">
          <fieldset class="uk-fieldset">
            <legend class="uk-legend">ジャンル</legend>
            <div class="uk-margin">
              <div class="uk-margin uk-grid-small uk-child-width-auto uk-grid">
                <label class="uk-margin-small-bottom"
                  ><input
                    class="uk-radio"
                    type="radio"
                    @change="handleChangeQuery"
                    v-model="genre"
                    name="radio1"
                    value=""
                    checked
                  />
                  全て</label
                >
                <label class="uk-margin-small-bottom"
                  ><input
                    class="uk-radio"
                    type="radio"
                    @change="handleChangeQuery"
                    v-model="genre"
                    name="radio1"
                    value="フォアハンド"
                  />
                  フォアハンド</label
                >
                <label class="uk-margin-small-bottom"
                  ><input
                    class="uk-radio"
                    type="radio"
                    @change="handleChangeQuery"
                    v-model="genre"
                    name="radio1"
                    value="バックハンド"
                  />
                  バックハンド</label
                >
                <label class="uk-margin-small-bottom"
                  ><input
                    class="uk-radio"
                    type="radio"
                    @change="handleChangeQuery"
                    v-model="genre"
                    name="radio1"
                    value="試合"
                  />
                  試合</label
                >
                <label class="uk-margin-small-bottom"
                  ><input
                    class="uk-radio"
                    type="radio"
                    @change="handleChangeQuery"
                    v-model="genre"
                    name="radio1"
                    value="フットワーク"
                  />
                  フットワーク</label
                >
                <label class="uk-margin-small-bottom"
                  ><input
                    class="uk-radio"
                    type="radio"
                    @change="handleChangeQuery"
                    v-model="genre"
                    name="radio1"
                    value="多球練習"
                  />
                  多球練習</label
                >
                <label class="uk-margin-small-bottom"
                  ><input
                    class="uk-radio"
                    type="radio"
                    @change="handleChangeQuery"
                    v-model="genre"
                    name="radio1"
                    value="サーブ"
                  />
                  サーブ</label
                >
                <label class="uk-margin-small-bottom"
                  ><input
                    class="uk-radio"
                    type="radio"
                    @change="handleChangeQuery"
                    v-model="genre"
                    name="radio1"
                    value="レシーブ・台上"
                  />
                  レシーブ・台上</label
                >
                <label class="uk-margin-small-bottom"
                  ><input
                    class="uk-radio"
                    type="radio"
                    @change="handleChangeQuery"
                    v-model="genre"
                    name="radio1"
                    value="その他"
                  />
                  その他</label
                >
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="uk-text-center f26">検索結果：{{num.length}}件</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      level: this.$store.state.level,
      genre: this.$store.state.genre,
      num: this.$store.state.items
    }
  },
  methods: {
    handleChangeQuery() {
      this.setFilter({level:this.level,genre:this.genre})
      this.filterList()
    },
    ...mapActions(['setFilter','filterList']),
  },
}
</script>